import images from "common/images";
import { SiteStatisticItemProps } from "pages/Site/pages/type";
import React from "react";
import "../../pages/styles/sitestatisticitem.scss";

const SiteStatisticItem = ({ item, onClick }: SiteStatisticItemProps) => {
  return (
    <div className="site-statistic-item-container" onClick={onClick}>
      <div className="site-statistic-item normal-button">
        <div className="site-statistic-image">
          <img src={images.yellowFolder} />
          <span className="site-statistic-total">{item.total}</span>
        </div>
        <span className="site-statistic-name">{item.name}</span>
      </div>
    </div>
  );
};

export default SiteStatisticItem;
